// src/hooks/useSelectStyles.ts
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';


export const useSelectStyles = () => {
	const layoutModeType = useSelector((state: ApplicationState) => state.layout.layoutModeType);

	const customStyles = {
		multiValue: (provided: any) => ({
  ...provided,
  backgroundColor: '#3f6ea0',
  borderRadius: 4,
  padding: '2px 4px',
}),

multiValueLabel: (provided: any) => ({
  ...provided,
  color: 'white',
  fontSize: '0.7rem',
  padding: '0 6px',
}),

multiValueRemove: (provided: any) => ({
  ...provided,
  color: 'white',
  ':hover': {
    backgroundColor: '#1b4c7e',
    color: 'white',
  },
}),
		control: (provided: any, state: any) => ({
			...provided,
			color: layoutModeType === 'light' ? 'black' : 'white',
			// fontWeight: 900,
			width: '100%',
			borderRadius: 3,
			boxShadow: 'none',
			backgroundColor: 'transparent',
		}),
		input: (provided: any) => ({
			...provided,
			color: layoutModeType === 'light' ? 'black' : 'white',
			fontWeight: 400,
			opacity: 0.7,
		}),
		menu: (provided: any) => ({
			...provided,
			backgroundColor: layoutModeType === 'light' ? 'white' : '#495057',
			color: layoutModeType === 'light' ? 'black' : 'white',
			borderRadius: 4,
		}),
		menuPortal: (base: any) => {
			const { zIndex, ...rest } = base;
			return { ...rest, zIndex: 9999 };
		},
		option: (provided: any, state: any) => ({
			...provided,
			backgroundColor: layoutModeType === 'light' ? 'white' : '#495057',
			color: layoutModeType === 'light' ? 'black' : 'white',
			'&:hover': {
				backgroundColor: layoutModeType === 'light' ? 'white' : '#495057',
			},
		}),
	};

	return customStyles;
};
